import type { FunctionComponent } from 'react';

export type SideNavigationScope = 'company' | 'me' | 'team';

const ORBITS: Record<SideNavigationScope, { readonly dot: number; readonly rings: readonly number[] }> = {
    company: { dot: 2.5, rings: [5.25, 8.5] },
    me: { dot: 3.4, rings: [] },
    team: { dot: 2.9, rings: [6.5] },
};

// The current scope's rings draw outward from the dot (theme/side-navigation.css),
// unless `settled`, when they are simply there.
export const ScopeOrbit: FunctionComponent<{
    readonly current: boolean;
    readonly scope: SideNavigationScope;
    readonly settled?: boolean;
}> = ({ current, scope, settled = false }) => {
    const orbit = ORBITS[scope];

    return (
        <svg
            aria-hidden="true"
            className="block shrink-0 overflow-visible"
            data-current={current ? '' : undefined}
            data-scope-orbit={scope}
            data-settled={settled ? '' : undefined}
            height={20}
            viewBox="0 0 20 20"
            width={20}
        >
            {orbit.rings.map((radius, index) => (
                <circle
                    key={radius}
                    className="scope-orbit-ring"
                    cx="10"
                    cy="10"
                    r={radius}
                    style={{ animationDelay: `${index * 60}ms` }}
                />
            ))}
            <circle className="scope-orbit-dot" cx="10" cy="10" r={orbit.dot} />
        </svg>
    );
};
